//main
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import EventsCreateModule from '../content/events/events-create';

import { UserForm } from "../services/srvc-utilities";

export default function EventsCreate() {

  return (
  <>
    <ContentFormatXX 
      head='Create Event'
      link={`/${UserForm()}/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <EventsCreateModule />


        </>
      } 
    />
  </>
  )
}